import React from "react";
import { useUrl } from "@/context/SiteContext";
import ServicePage from "./ServicePage";

export default function ImprimarePlasticPage() {
  const url = useUrl();
  return (
    <ServicePage
      backLabel="Tehnologii imprimare 3D"
      backTo={url.dept("tehnologii-imprimare-3d")}
      number="01"
      eyebrow="Tehnologie SLS"
      title={["Imprimare 3D", "din plastic."]}
      tagline="Rapid · Versatil · Flexibil · Accesibil — imprimare Selective Laser Sintering pentru piese în serie mică, prototipuri funcționale și matrițe de ștanțare."
      intro={[
        "Tehnologia SLS (Selective Laser Sintering) se distinge prin precizie înaltă și oferă posibilitatea de a produce prototipuri, produse noi sau serii mici direct la sediul tău. Imprimanta este concepută să eficientizeze fluxul de lucru — optimizează timpul de așteptare și costurile per piesă, producând componente cu adevărat funcționale.",
        "Precizia dimensională excelentă și detaliile fine duc la rezultate repetabile, esențiale pentru industria aerospațială, medicală, auto și electronica industrială. SLS este una dintre cele mai avansate și versatile tehnologii pentru piese cu duritate și flexibilitate remarcabile.",
      ]}
      bullets={[
        "Prototipuri funcționale și componente finale.",
        "Producție serie mică cu cost per bucată optimizat.",
        "Detalii fine, rezoluție excelentă a suprafeței.",
        "Materiale variate pentru duritate + flexibilitate.",
      ]}
      programs={[
        "Aerospațial", "Auto", "Feroviar",
        "Larg consum", "Educație", "Electronică",
        "Asistență medicală", "Cercetare",
      ]}
      servicesEyebrow="Materiale disponibile"
      servicesTitle="11 filamente pentru orice cerință."
      services={[
        {
          title: "PA12 Smooth (Nylon 12)",
          tags: "Cost/calitate echilibrat · rezistență chimică · detalii fine.",
          desc: "Pulbere de Nylon 12 cu rezoluție excelentă a suprafeței, ideală pentru prototipuri generale și obiecte cu detalii fine. Permite geometrii spațiale complexe și elemente structurale, cu rezistență la substanțe chimice pentru aplicații industriale.",
        },
        {
          title: "Flexa Grey",
          tags: "TPU · elastic · absorbție șocuri · protecții personalizate.",
          desc: "Material plastic cu caracteristici elastice remarcabile — fabricare articole standard din cauciuc, prototipuri avansate, componente specializate pentru absorbția șocurilor și vibrațiilor. Soluție ideală pentru protecții personalizate.",
        },
        {
          title: "PLA",
          tags: "Rapid de imprimat · finisaje netede · precizie mare.",
          desc: "Filament extrem de popular și versatil. Permite imprimare rapidă și produce finisaje de înaltă calitate pe obiecte cu detalii fine, potrivit pentru o gamă largă de aplicații în printarea 3D.",
        },
        {
          title: "PETG",
          tags: "Rezistență la șocuri și apă · aderență între straturi.",
          desc: "Polietilen tereftalat glicol — termoplastic flexibil, ușor de utilizat, cu aderență remarcabilă între straturi. Structură uniformă și solidă, potrivit pentru obiecte de uz casnic sau componente industriale supuse uzurii frecvente.",
        },
        {
          title: "TPU",
          tags: "Poliuretan termoplastic · duritate + flexibilitate · uzură constantă.",
          desc: "Material versatil, moale, care îmbină duritatea cu flexibilitatea. Aderență între straturi remarcabilă, tendință redusă de deformare — potrivit pentru obiecte supuse uzurii constante care trebuie să-și păstreze forma inițială.",
        },
        {
          title: "PVA",
          tags: "Adeziv pentru materiale poroase · lemn · hârtie · pânză.",
          desc: "Poliacetat de vinil — adeziv specializat pentru lipirea materialelor poroase. Legătură puternică și durabilă în lucrări de lemnărie, proiecte de artă și industria de prelucrare a hârtiei.",
        },
        {
          title: "PET-CF",
          tags: "Duritatea fibrei de carbon · rezistență termică · stabilitate dimensională.",
          desc: "Material avansat care combină duritatea fibrei de carbon cu proprietățile PET-ului. Rezistent la temperaturi înalte și cu stabilitate dimensională de încredere — ideal pentru structuri supuse solicitărilor intense și mediilor umede.",
        },
        {
          title: "PA6-CF",
          tags: "Poliamidă 6 + fibră carbon · rigiditate · componente structurale.",
          desc: "Filament din poliamidă 6 (PA6) îmbogățit cu fibră de carbon. Combinație notabilă de rigiditate și rezistență, potrivit pentru producția de componente structurale și mecanice cu performanțe excepționale în medii uscate.",
        },
        {
          title: "PC (Policarbonat)",
          tags: "Rezistență termică · proprietăți mecanice superioare · inginerie.",
          desc: "Rezistență termică de excepție și proprietăți mecanice superioare — potrivit pentru utilizări în inginerie, unde durabilitatea și stabilitatea la temperaturi ridicate sunt esențiale.",
        },
        {
          title: "ABS",
          tags: "Durabilitate · impact · variații de temperatură.",
          desc: "Acrylonitrile Butadiene Styrene — material de înaltă rezistență care îmbină durabilitatea cu capacitatea de a rezista la temperaturi ridicate și scăzute. Utilizat frecvent în industria producției, imprimarea 3D și construcții.",
        },
        {
          title: "ASA",
          tags: "Rezistență UV · exterior · durabilitate lungă.",
          desc: "Acrylonitrile Styrene Acrylate — se remarcă prin rezistență la radiația UV și condiții meteorologice variate. Ideal pentru modele exterioare și piese structurale expuse pe termen lung la mediul exterior.",
        },
      ]}
      stepsEyebrow="De ce SLS la Suntec"
      stepsTitle="Patru motive tehnice."
      steps={[
        {
          title: "Calitate superioară",
          desc: "Tehnologia SLS oferă detalii de înaltă precizie și un standard de referință pentru prototipuri fiabile — verificate în teste sau trimise ca eșantioane funcționale clienților pentru validare.",
        },
        {
          title: "Materiale diverse",
          desc: "PA12 Smooth pentru prototipuri structurale + FLEXA Grey pentru piese elastice care absorb șocuri. Împreună — inovații în design industrial și personalizarea produselor.",
        },
        {
          title: "Producție eficientă",
          desc: "Pentru numărul redus de piese: reacție rapidă, libertate în design, cost eficient. Varietate largă de materiale suportate, arhitectură compactă, investiție rezonabilă.",
        },
      ]}
    />
  );
}
